module.exports = __webpack_public_path__ + "static/media/img_sendero.7fc2e8ab.jpg";